export default {"src":"/_next/static/media/banner_bg_img.0bf04f99.svg","height":809,"width":809,"blurWidth":0,"blurHeight":0};